import { useContext } from "react";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context.ts";
import { BotType } from "@shared/types";
import { BotFormType } from "@shared/features/bots/BotForm/common/types.ts";
import Switch from "common/Buttons/Switch.tsx";
import Text from "common/Typography/Text.tsx";

const SymbolFromAlertToggle = () => {
  const { botFormType, botType, useSymbolFromAlert, setUseSymbolFromAlert } =
    useContext(BotFormContext)!;
  const isTradingViewBot = botType === BotType.TRADING_VIEW;
  const isTradingViewSignalsBot = botType === BotType.TRADING_VIEW_SIGNALS;
  const isBulkEdit = botFormType === BotFormType.BULK_EDIT;
  const isBotEdit = botFormType === BotFormType.EDIT || isBulkEdit;

  if ((!isTradingViewBot && !isTradingViewSignalsBot) || isBotEdit) return;

  return (
    <div
      style={{
        marginTop: 12,
        cursor: "pointer",
        width: "fit-content",
        opacity: 1,
      }}
      onClick={() => {
        setUseSymbolFromAlert(!useSymbolFromAlert);
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <Switch
          size="small"
          checked={!!useSymbolFromAlert}
          onChange={setUseSymbolFromAlert}
        />
        <Text>Use symbol from alert</Text>
      </div>
    </div>
  );
};

export default SymbolFromAlertToggle;
